module.exports = __webpack_public_path__ + "img/_mongolia.048d2b93.png";